export function preserveApproximationTildes(text) {
  return text.replace(/(^|[^~])~(?=\s*\d)/g, '$1\\~');
}
